import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import RunningKPI from '../kpi-dashboard/RunningKPI';
import { buildSicBoardPath, SIC_BOARD_TYPE } from 'helpers/sicHelper';

export default function SicBoardList() {
  return (
    <>
      <PageHeader
        title="SIC Scorecard"
        description="Manage and view all available SIC boards from this page."
        className="mb-3"
      />
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <RunningKPI
            boardType={SIC_BOARD_TYPE.sic}
            title="SIC Boards"
            buildDetailPath={buildSicBoardPath}
          />
        </Col>
      </Row>
    </>
  );
}
